import { render } from "./Glyphloop.vue?vue&type=template&id=97bf2f12&scoped=true"
import script from "./Glyphloop.vue?vue&type=script&lang=js"
export * from "./Glyphloop.vue?vue&type=script&lang=js"

import "./Glyphloop.vue?vue&type=style&index=0&id=97bf2f12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97bf2f12"]])

export default __exports__